/*
 * @Author: 赵泽文
 * @Date: 2022-03-07 16:36:38
 * @LastEditors: nhsoft.zhangxh
 * @LastEditTime: 2023-10-12 16:35:00
 * @Description: 退货单数据存储
 */

import type {
  IEarthTransferInOrderModel,
  IEarthTransferInOrderStore,
} from '@monorepo/types/earthOrders/transferInOrder/transferInOrder.types';

import { getToday } from '@monorepo/utils';
import { tableUpdate } from '@monorepo/utils';
// import moment from 'moment';

const initState: IEarthTransferInOrderStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
    date_from: '',
    date_to: '',
    date: getToday(),
    date_type: '制单时间',
  },
  auditNo: '',
  // auditProductList: [],
};

const earthTransferInOrderStore: IEarthTransferInOrderModel = {
  namespace: 'earthTransferInOrderStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return {
        ...state,
        tableList,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default earthTransferInOrderStore;
